export default "__VITE_ASSET__DCy86$xq__"